import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    // Assign src to the sources for the current viewport only, so just one rendition
    // downloads. When no mobile-tagged source exists, every source is used (the desktop
    // video plays on all breakpoints — the fallback for videos without a mobile upload).
    const isMobile = !window.matchMedia('(min-width: 750px)').matches;
    const hasMobile = videoSources.some((source) => source.dataset.viewport === 'mobile');
    const want = isMobile ? 'mobile' : 'desktop';

    for (const source of videoSources) {
      const useSource = hasMobile ? source.dataset.viewport === want : true;
      const { videoSource } = source.dataset;

      if (useSource && videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
